import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthSessionService } from '../services/auth/auth-session.service';
import { HTTP_REQUEST_TIMEOUT_MS } from '../utils/http/http-request-context';

// intercept each API request and if available inject the AccessToken
// without having to include this in each service call

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private sessions: AuthSessionService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.headers.get('Request-Type') === 'arcgis') {
      return next.handle(request);
    } else {
      const due = request.context.get(HTTP_REQUEST_TIMEOUT_MS);
      // add authorization header with jwt token if available
      const accessToken = this.sessions.getAccessToken();

      let headers: any = {
        setHeaders: {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': environment.apimSubscriptionKey,
        },
      };

      const requstURL: string = request.url;

      if (requstURL.indexOf('blob.core') > 0) {
        headers = request.headers.get('Request-Type') === 'commit'
          ? {}
          : { setHeaders: { 'x-ms-blob-type': 'BlockBlob' } };
      } else if (accessToken) {
        headers['setHeaders']['Authorization'] =
          'Bearer ' + accessToken;
      }

      request = request.clone(headers);
      return next.handle(request).pipe(timeout(due));
    }
  }
}
